import React from 'react'
import GenLayout from './layout'

const GenAI:React.FC<{}> = () => {
    return (
      <GenLayout />
    )
  }
  
  export default GenAI